import React from 'react'
import PropTypes from 'prop-types'

const debug = false
// const debug = "UI5CalendarPresets"

export default class UI5CalendarPresets extends React.Component {
    static propTypes = {
        presets     : PropTypes.arrayOf(PropTypes.shape({
            label       : PropTypes.string,
            icon        : PropTypes.string,
            className   : PropTypes.string,
            onClick     : PropTypes.func,
        })),
        noBackground: PropTypes.bool,
    }

    render() {
        debug && console.log(debug, "render", this.props.presets)

        if (_.isEmpty(this.props.presets)) return false

        const classes = Classes("presets ui5-menu", {
            'no-background': this.props.noBackground
        })

        return (
            <div className={classes}>
                {_.map(this.props.presets, (btn,key)=>(
                    <div key        = {key}
                         className  = {Classes("item", btn.className)}
                         onClick    = {btn.onClick}>
                        <div className="row">
                            {!!btn.icon && <div className={Classes("icon", btn.icon)}/>}
                            <div className="name">{btn.label}</div>
                        </div>
                    </div>
                ))}
            </div>
        )
    }
}